<template>
  <div class="channel-audit">
    <!-- 页面头部 -->
<!--    <div class="page-header">-->
<!--      <div class="header-left">-->
<!--        <h2 class="page-title"><i class="el-icon-s-check"></i> 渠道审核</h2>-->
<!--        <span class="page-desc">审核渠道入驻申请，管理渠道审核状态及审核概览</span>-->
<!--      </div>-->
<!--      <div class="header-right">-->
<!--        <el-button icon="el-icon-refresh" size="small" @click="refreshList">刷新</el-button>-->
<!--      </div>-->
<!--    </div>-->

    <!-- 审核概览 -->
    <div class="section-title"><i class="el-icon-finished"></i> 审核概览</div>
    <el-row :gutter="16" class="stat-row">
      <el-col :span="6">
        <div class="stat-card pending" @click="filterByStatus(0)">
          <div class="stat-icon">
            <i class="el-icon-time"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">待审核</div>
            <div class="stat-value">{{ auditStatistics.pendingCount }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card passed" @click="filterByStatus(1)">
          <div class="stat-icon">
            <i class="el-icon-check"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">已通过</div>
            <div class="stat-value">{{ auditStatistics.passedCount }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card rejected" @click="filterByStatus(2)">
          <div class="stat-icon">
            <i class="el-icon-close"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">已拒绝</div>
            <div class="stat-value">{{ auditStatistics.rejectedCount }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6" style="overflow: hidden;">
        <div class="stat-card today">
          <div class="stat-icon">
            <i class="el-icon-date"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">今日新增</div>
            <div class="stat-value">{{ auditStatistics.todayCount }}</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 筛选栏 -->
    <div class="filter-bar">
      <el-radio-group v-model="searchForm.status" @change="handleSearch">
        <el-radio-button :label="100">全部</el-radio-button>
        <el-radio-button label="0">待审核</el-radio-button>
        <el-radio-button label="1">审核通过</el-radio-button>
        <el-radio-button label="3">审核拒绝</el-radio-button>
        <!--        <el-radio-button-->
        <!--          v-for="item in statusOptions"-->
        <!--          :key="item.value"-->
        <!--          :label="item.value">-->
        <!--          {{ item.label }}-->
        <!--        </el-radio-button>-->
      </el-radio-group>
      <el-button icon="el-icon-refresh" @click="refreshList">刷新</el-button>
    </div>

    <!-- 列表 -->
    <custom-table ref="customTable" has-organization="true" :customOptions="customOptions" :columns="columns">
      <template slot="table-operation">
        <el-table-column label="操作" width="180" fixed="right" align="center">
          <div slot-scope="{row}" class="custom-action">
            <el-button type="text" @click="handleDetail(row,'view')">查看</el-button>
            <el-button v-if="row.status === 0" type="text" class="audit-btn" @click="handleAudit(row,'audit')">审核</el-button>
            <!-- <el-button v-if="row.status === 1" type="text" @click="goToDetail(row)">详情</el-button> -->
          </div>
        </el-table-column>
      </template>

      <template slot-scope="{item, row}">
        <template v-if="item.prop === 'channelNo'">
          <div class="channel-no-cell">
            <span class="channel-no" @click="handleDetail(row)">{{ row.channelNo || '待生成' }}</span>
            <el-tag :type="getstatusType(row.status)" size="medium">
              {{ row.status | filterConst('CHANNEL_AUDIT_STATUS') }}
            </el-tag>
          </div>
        </template>
        <template v-else-if="item.prop === 'name'">
          <div class="name-cell">
            <span class="name">{{ row.name }}</span>
            <span class="work-area">{{ row.workArea }}</span>
          </div>
        </template>
        <template v-else-if="item.prop === 'phone'">
          <div class="phone-cell" @dblclick="$utils.copyText(row.phone)">
            {{ row.phone | filterMaskPhone }}
            <i class="el-icon-document-copy copy-icon" @click.stop="$utils.copyText(row.phone)"></i>
          </div>
        </template>
        <template v-else-if="item.prop === 'idCard'">
          {{ row.idCard | filterMaskIdCard }}
        </template>
        <template v-else-if="item.prop === 'createTime' || item.prop === 'created'">
          {{ (row.created || row.createTime) | filterTime }}
        </template>
        <template v-else-if="item.prop === 'auditTime'">
          {{ row.auditTime | filterTime }}
        </template>
        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] || '-' }}</span>
        </template>
      </template>
    </custom-table>

    <!-- 查看/审核抽屉 -->
    <el-drawer :visible.sync="drawerVisible" :title="drawerTitle" :size="drawerSize" direction="rtl"
      :before-close="handleDrawerClose" custom-class="audit-drawer">
      <div class="drawer-content" v-loading="drawerLoading">
        <!-- 顶部状态栏 -->
        <div class="drawer-status-bar" :class="getStatusBarClass(currentRow.status)">
          <div class="status-info">
            <el-tag :type="getstatusType(currentRow.status)" size="medium" effect="dark">
              {{ currentRow.status | filterConst('CHANNEL_STATUS') }}
            </el-tag>
            <span class="status-text" v-if="currentRow.status === 0">该申请正在等待审核</span>
            <span class="status-text" v-else-if="currentRow.status === 1">审核已通过，渠道已激活</span>
            <span class="status-text" v-else-if="currentRow.status === 3">审核已拒绝</span>
            <span class="status-text" v-else-if="currentRow.status === 2">渠道已禁用</span>
          </div>
          <div class="status-time" v-if="currentRow.status !== 0">
            审核时间：{{ currentRow.auditTime | filterTime }}
          </div>
        </div>

        <!-- 基本信息卡片 -->
        <div class="drawer-section">
          <div class="section-header">
            <i class="el-icon-user"></i>
            <span>基本信息</span>
          </div>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">渠道编号</span>
              <span class="info-value">
                {{ currentRow.channelNo || '审核通过后自动生成' }}
                <el-button v-if="currentRow.channelNo" type="text" size="mini" icon="el-icon-document-copy"
                  @click="$utils.copyText(currentRow.channelNo)"></el-button>
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">姓名</span>
              <span class="info-value highlight">{{ currentRow.name }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">手机号</span>
              <span class="info-value">
                {{ currentRow.phone }}
                <el-button type="text" size="mini" icon="el-icon-document-copy"
                  @click="$utils.copyText(currentRow.phone)"></el-button>
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">身份证号</span>
              <span class="info-value">
                {{ currentRow.idCard }}
                <el-button type="text" size="mini" icon="el-icon-document-copy"
                  @click="$utils.copyText(currentRow.idCard)"></el-button>
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">机构名称</span>
              <span class="info-value">{{ currentRow.organizationName || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">工作区域</span>
              <span class="info-value">{{ currentRow.workArea || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">提交时间</span>
              <span class="info-value">{{ (currentRow.created || currentRow.createTime) | filterTime }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">推荐人</span>
              <span class="info-value">{{ currentRow.referrerId ? '有' : '无' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">支付宝账号</span>
              <span class="info-value">{{ currentRow.alipayAccount || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">支付宝姓名</span>
              <span class="info-value">{{ currentRow.alipayName || '-' }}</span>
            </div>
            <div class="info-item full">
              <span class="info-label">备注</span>
              <span class="info-value">{{ currentRow.remark || '-' }}</span>
            </div>
          </div>
        </div>

        <!-- 统计信息 -->
        <div class="drawer-section" v-if="currentRow.status === 1">
          <div class="section-header">
            <i class="el-icon-data-line"></i>
            <span>统计信息</span>
          </div>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">订单数量</span>
              <span class="info-value highlight">{{ currentRow.orderCount || 0 }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">累计佣金</span>
              <span class="info-value highlight">¥{{ formatMoney(currentRow.totalCommission) }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">累计提现</span>
              <span class="info-value">¥{{ formatMoney(currentRow.totalWithdrawal) }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">账户余额</span>
              <span class="info-value highlight">¥{{ formatMoney(currentRow.balance) }}</span>
            </div>
          </div>
        </div>

        <!-- 身份证照片与OCR -->
        <div class="drawer-section">
          <div class="section-header">
            <i class="el-icon-postcard"></i>
            <span>身份证照片与OCR识别</span>
          </div>
          <div class="id-card-section">
            <div class="id-card-images">
              <div class="id-card-item">
                <div class="id-card-label">身份证正面</div>
                <div class="id-card-img" @click="previewImage(getIdCardImageUrl(currentRow.idCardFront))">
                  <el-image v-if="currentRow.idCardFront" :src="getIdCardImageUrl(currentRow.idCardFront)" fit="cover"
                    :preview-src-list="[getIdCardImageUrl(currentRow.idCardFront)]">
                  </el-image>
                  <div v-else class="no-image">
                    <i class="el-icon-picture-outline"></i>
                    <span>暂无图片</span>
                  </div>
                </div>
              </div>
              <div class="id-card-item">
                <div class="id-card-label">身份证反面</div>
                <div class="id-card-img" @click="previewImage(getIdCardImageUrl(currentRow.idCardBack))">
                  <el-image v-if="currentRow.idCardBack" :src="getIdCardImageUrl(currentRow.idCardBack)" fit="cover"
                    :preview-src-list="[getIdCardImageUrl(currentRow.idCardBack)]">
                  </el-image>
                  <div v-else class="no-image">
                    <i class="el-icon-picture-outline"></i>
                    <span>暂无图片</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="ocr-result" v-if="currentRow.gender || currentRow.nation || currentRow.birthDate">
              <div class="ocr-item">
                <span class="ocr-label">性别</span>
                <span class="ocr-value">{{ currentRow.gender || '-' }}</span>
              </div>
              <div class="ocr-item">
                <span class="ocr-label">民族</span>
                <span class="ocr-value">{{ currentRow.nation || '-' }}</span>
              </div>
              <div class="ocr-item">
                <span class="ocr-label">出生日期</span>
                <span class="ocr-value">{{ currentRow.birthDate || '-' }}</span>
              </div>
              <div class="ocr-item full">
                <span class="ocr-label">住址</span>
                <span class="ocr-value">{{ currentRow.address || '-' }}</span>
              </div>
              <div class="ocr-item">
                <span class="ocr-label">有效期</span>
                <span class="ocr-value">{{ currentRow.validPeriod || '-' }}</span>
              </div>
              <div class="ocr-item full">
                <span class="ocr-label">签发机关</span>
                <span class="ocr-value">{{ currentRow.issuingAuthority || '-' }}</span>
              </div>
            </div>
            <el-empty v-else description="暂无OCR识别数据" :image-size="60"></el-empty>
          </div>
        </div>

<!--        &lt;!&ndash; 人脸识别验证 &ndash;&gt;-->
<!--        <div class="drawer-section">-->
<!--          <div class="section-header">-->
<!--            <i class="el-icon-camera"></i>-->
<!--            <span>人脸识别验证</span>-->
<!--            <el-tag v-if="currentRow.verifyResult" size="mini"-->
<!--              :type="currentRow.verifyResult === 'pass' ? 'success' : 'danger'">-->
<!--              {{ currentRow.verifyResult === 'pass' ? '验证通过' : '验证失败' }}-->
<!--            </el-tag>-->
<!--          </div>-->
<!--          <div class="face-section" v-if="currentRow.verifyResult || currentRow.similarity || currentRow.liveScore">-->
<!--            <div class="face-image">-->
<!--              <el-image v-if="currentRow.faceImage" :src="getIdCardImageUrl(currentRow.faceImage)" fit="cover"-->
<!--                :preview-src-list="[getIdCardImageUrl(currentRow.faceImage)]">-->
<!--              </el-image>-->
<!--              <div v-else class="no-image">-->
<!--                <i class="el-icon-user"></i>-->
<!--                <span>暂无照片</span>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="face-stats">-->
<!--              <div class="face-stat-item" v-if="currentRow.similarity !== null && currentRow.similarity !== undefined">-->
<!--                <div class="stat-circle" :class="parseFloat(currentRow.similarity || 0) >= 0.85 ? 'success' : 'danger'">-->
<!--                  <span class="stat-num">{{ (parseFloat(currentRow.similarity || 0) * 100).toFixed(0) }}</span>-->
<!--                  <span class="stat-unit">%</span>-->
<!--                </div>-->
<!--                <div class="stat-label">人脸相似度</div>-->
<!--                <div class="stat-threshold">阈值: 85%</div>-->
<!--              </div>-->
<!--              <div class="face-stat-item" v-if="currentRow.liveScore !== null && currentRow.liveScore !== undefined">-->
<!--                <div class="stat-circle" :class="parseFloat(currentRow.liveScore || 0) >= 0.90 ? 'success' : 'danger'">-->
<!--                  <span class="stat-num">{{ (parseFloat(currentRow.liveScore || 0) * 100).toFixed(0) }}</span>-->
<!--                  <span class="stat-unit">%</span>-->
<!--                </div>-->
<!--                <div class="stat-label">活体检测</div>-->
<!--                <div class="stat-threshold">阈值: 90%</div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <el-empty v-else description="暂无人脸识别数据" :image-size="60"></el-empty>-->
<!--        </div>-->

        <!-- 已审核信息 -->
        <div class="drawer-section" v-if="currentRow.status !== 0">
          <div class="section-header">
            <i class="el-icon-document-checked"></i>
            <span>审核信息</span>
          </div>
          <div class="audit-info">
            <div class="audit-item">
              <span class="audit-label">审核结果</span>
              <el-tag :type="getstatusType(currentRow.status)" size="medium">
                {{ currentRow.status | filterConst('CHANNEL_AUDIT_STATUS') }}
              </el-tag>
            </div>
            <div class="audit-item">
              <span class="audit-label">审核时间</span>
              <span class="audit-value">{{ currentRow.auditTime | filterTime }}</span>
            </div>
            <div class="audit-item">
              <span class="audit-label">审核人</span>
              <span class="audit-value">{{ currentRow.auditOperator || '-' }}</span>
            </div>
            <div class="audit-item full">
              <span class="audit-label">审核备注</span>
              <span class="audit-value">{{ currentRow.auditRemark || '-' }}</span>
            </div>
          </div>
        </div>

      </div>

      <!-- 抽屉底部操作栏 -->
      <div class="drawer-footer">
        <el-button @click="drawerVisible = false">关闭</el-button>
      </div>
    </el-drawer>

    <!-- 审核弹框 -->
    <audit-dialog
      :visible.sync="auditDialogVisible"
      :channel-id="currentAuditChannelId"
      @success="handleAuditSuccess">
    </audit-dialog>
  </div>
</template>

<script>
import AuditDialog from './components/auditDialog.vue'

export default {
  name: 'channelAudit',
  components: {
    AuditDialog
  },
  data() {
    return {
      auditStatistics: {
        pendingCount: 0,
        passedCount: 0,
        rejectedCount: 0,
        todayCount: 0
      },
      searchForm: {
        status: '0'
      },
      customOptions: {
        url: '/api/v1/channel/list',
        method: 'get',
        params: {
          page: 1,
          size: 10,
          status: '0'
        },
        search: [
          { type: 'input', field: 'keyword', name: '关键词', value: '' },
          { type: 'daytime', field: 'Time', name: '提交时间', value: '', clearable: true, disabledDate: true }
        ]
      },
      columns: [
        { label: '渠道编号', prop: 'channelNo', minWidth: 180, align: 'left' },
        { label: '姓名', prop: 'name', minWidth: 100, align: 'left' },
        { label: '手机号', prop: 'phone', minWidth: 120, align: 'left' },
        { label: '身份证号', prop: 'idCard', minWidth: 160, align: 'left' },
        { label: '机构名称', prop: 'organizationName', minWidth: 120, align: 'left' },
        { label: '提交时间', prop: 'createTime', minWidth: 160, align: 'left' }
      ],
      // 抽屉相关
      drawerVisible: false,
      drawerTitle: '渠道详情',
      drawerSize: '680px',
      drawerLoading: false,
      currentRow: {},
      // 审核弹框相关
      auditDialogVisible: false,
      currentAuditChannelId: null
    }
  },
  created() {
    // this.customOptions.customFn = this.getList
  },
  mounted() {

    this.loadAuditStatistics()
  },
  methods: {
    handleSearch() {
      this.customOptions.params.status = this.searchForm.status === 100 ? '' : this.searchForm.status


      this.$refs.customTable.getList()
    },
    refreshList() {
      this.$refs.customTable.getList()
      this.loadAuditStatistics()
    },
    filterByStatus(status) {
      this.searchForm.status = status
      this.handleSearch()
    },
    // 查看详情
    async handleDetail(row, type) {
      // 先重置状态，避免闪烁
      this.drawerLoading = false
      this.currentRow = { ...row, typeView: type }
      this.drawerTitle = '渠道详情'
      this.drawerVisible = true

      // 调用详情接口获取完整数据
      this.drawerLoading = true
      try {
        const res = await this.$axios.get('/api/v1/channel/detail', { id: row.id })
        if (res && res.code === 1 && res.data) {
          // 将详情数据合并到 currentRow 中
          this.currentRow = { ...this.currentRow, ...res.data }
        }
      } catch (error) {
        this.$message.error('获取渠道详情失败')
      } finally {
        this.drawerLoading = false
      }
    },
    // 审核
    handleAudit(row, type) {
      this.currentAuditChannelId = row.id
      this.auditDialogVisible = true
    },
    // 审核成功回调
    handleAuditSuccess() {
      // 刷新列表和统计
      this.$refs.customTable.getList()
      this.loadAuditStatistics()
    },
    // 跳转到渠道详情页
    goToDetail(row) {
      this.$router.push({
        path: '/channelDetail',
        query: { id: row.id }
      })
    },
    // 抽屉关闭前确认
    handleDrawerClose(done) {
      // 关闭时重置 loading 状态，避免闪烁
      this.drawerLoading = false
      done()
    },
    // 获取状态栏样式类
    getStatusBarClass(status) {
      if (status === 0) return 'pending'
      if (status === 1) return 'passed'
      return 'rejected'
    },
    getstatusType(status) {
      const statusItem = this.$const.CHANNEL_AUDIT_STATUS.find(i => i.value === status)
      return statusItem ? statusItem.type : ''
    },
    /**
     * 获取身份证图片完整URL
     * 作者：孙艺
     * @param {String} imageKey - 图片key（hash）
     * @returns {String} 完整的图片URL
     */
    getIdCardImageUrl(imageKey) {
      if (!imageKey) {
        return ''
      }
      // 如果已经是完整URL（包含http或https），直接返回
      if (imageKey.startsWith('http://') || imageKey.startsWith('https://') || imageKey.startsWith('data:')) {
        return imageKey
      }
      // 拼接七牛云前缀
      return window.configure.qiniuUrl + imageKey
    },
    /**
     * 格式化金额
     * 作者：孙艺
     * @param {Number|String} amount - 金额
     * @returns {String} 格式化后的金额字符串
     */
    formatMoney(amount) {
      if (amount === null || amount === undefined || amount === '') {
        return '0.00'
      }
      const num = parseFloat(amount)
      if (isNaN(num)) {
        return '0.00'
      }
      return num.toFixed(2)
    },
    // 图片预览
    previewImage(url) {
      // el-image组件已内置预览功能
    },
    /**
     * 加载审核统计数据
     * 作者：孙艺
     */
    async loadAuditStatistics() {
      try {
        const res = await this.$axios.get('/api/v1/channel/auditStatistics')
        if (res && res.code === 1 && res.data) {
          // 映射后端返回的字段到前端数据结构
          this.auditStatistics = {
            pendingCount: res.data.pendingCount || 0,
            passedCount: res.data.approvedCount || 0, // approvedCount 包括正常和禁用状态
            rejectedCount: res.data.rejectedCount || 0,
            todayCount: res.data.todayNewCount || 0
          }
        }
      } catch (error) {
        console.error('加载统计数据失败:', error)
        this.$message.error('加载统计数据失败')
      }
    }
  },
  computed: {
    statusOptions() {
      return this.$const.CHANNEL_STATUS || []
    },
  }
}
</script>

<style lang="less" scoped>
@import '../channel.less';

// 页面容器
.channel-audit {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

// 列表单元格样式
.channel-no-cell {
  display: flex;
  align-items: center;
  gap: 8px;

  .channel-no {
    color: #409EFF;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

.name-cell {
  .name {
    display: block;
    font-weight: 500;
    color: #303133;
  }

  .work-area {
    font-size: 12px;
    color: #909399;
  }
}

.phone-cell {
  display: flex;
  align-items: center;

  .copy-icon {
    margin-left: 6px;
    color: #C0C4CC;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.2s;

    &:hover {
      color: #409EFF;
    }
  }

  &:hover .copy-icon {
    opacity: 1;
  }
}

.audit-btn {
  color: #E6A23C !important;
}

// 抽屉样式
/deep/ .audit-drawer {
  .el-drawer__header {
    margin-bottom: 0;
    padding: 16px 20px;
    border-bottom: 1px solid #EBEEF5;
  }

  .el-drawer__body {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    position: relative;
  }
}

.drawer-content {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 70px;
  min-height: 0;
}

// 状态栏
.drawer-status-bar {
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &.pending {
    background: linear-gradient(135deg, #E6A23C15 0%, #E6A23C08 100%);
    border-bottom: 2px solid #E6A23C;
  }

  &.passed {
    background: linear-gradient(135deg, #67C23A15 0%, #67C23A08 100%);
    border-bottom: 2px solid #67C23A;
  }

  &.rejected {
    background: linear-gradient(135deg, #F56C6C15 0%, #F56C6C08 100%);
    border-bottom: 2px solid #F56C6C;
  }

  .status-info {
    display: flex;
    align-items: center;
    gap: 12px;

    .status-text {
      font-size: 14px;
      color: #606266;
    }
  }

  .status-time {
    font-size: 13px;
    color: #909399;
  }
}

// 抽屉区块
.drawer-section {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;

  .section-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    font-size: 15px;
    font-weight: 600;
    color: #303133;

    i {
      color: #409EFF;
    }

    .el-tag {
      margin-left: auto;
    }
  }
}

// 信息网格
.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;

  .info-item {
    display: flex;
    flex-direction: column;
    padding: 10px 12px;
    background: #fafafa;
    border-radius: 6px;

    .info-label {
      font-size: 12px;
      color: #909399;
      margin-bottom: 4px;
    }

    .info-value {
      font-size: 14px;
      color: #303133;
      display: flex;
      align-items: center;

      &.highlight {
        font-weight: 600;
        color: #409EFF;
      }
    }
  }
}

// 身份证区域
.id-card-section {
  .id-card-images {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;

    .id-card-item {
      flex: 1;

      .id-card-label {
        font-size: 12px;
        color: #909399;
        margin-bottom: 8px;
        text-align: center;
      }

      .id-card-img {
        width: 222px; // 身份证标准宽度（按比例计算：140px * 1.585 ≈ 222px）
        height: 140px; // 身份证标准高度
        border-radius: 8px;
        overflow: hidden;
        border: 1px dashed #DCDFE6;
        cursor: pointer;
        margin: 0 auto;
        position: relative;

        &:hover {
          border-color: #409EFF;
        }

        .el-image {
          width: 100%;
          height: 100%;
        }

        .no-image {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #fafafa;
          color: #C0C4CC;

          i {
            font-size: 32px;
            margin-bottom: 8px;
          }

          span {
            font-size: 12px;
          }
        }
      }
    }
  }

  .ocr-result {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    padding: 12px;
    background: #fafafa;
    border-radius: 6px;

    .ocr-item {
      display: flex;
      align-items: center;
      padding: 6px 10px;
      background: #fff;
      border-radius: 4px;
      font-size: 13px;

      &.full {
        grid-column: span 2;
      }

      &.match i {
        color: #67C23A;
      }

      &.mismatch i {
        color: #F56C6C;
      }

      .ocr-label {
        color: #909399;
        width: 70px;
        flex-shrink: 0;
      }

      .ocr-value {
        color: #303133;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      i {
        margin-left: 8px;
        font-size: 14px;
      }
    }
  }
}

// 人脸识别区域
.face-section {
  display: flex;
  gap: 20px;

  .face-image {
    width: 120px;
    height: 150px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px dashed #DCDFE6;
    flex-shrink: 0;

    .el-image {
      width: 100%;
      height: 100%;
    }

    .no-image {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #fafafa;
      color: #C0C4CC;

      i {
        font-size: 40px;
        margin-bottom: 8px;
      }

      span {
        font-size: 12px;
      }
    }
  }

  .face-stats {
    flex: 1;
    display: flex;
    gap: 20px;

    .face-stat-item {
      flex: 1;
      text-align: center;
      padding: 16px;
      background: #fafafa;
      border-radius: 8px;

      .stat-circle {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        margin: 0 auto 12px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.success {
          background: linear-gradient(135deg, #67C23A20 0%, #67C23A10 100%);
          border: 3px solid #67C23A;

          .stat-num {
            color: #67C23A;
          }
        }

        &.danger {
          background: linear-gradient(135deg, #F56C6C20 0%, #F56C6C10 100%);
          border: 3px solid #F56C6C;

          .stat-num {
            color: #F56C6C;
          }
        }

        .stat-num {
          font-size: 24px;
          font-weight: 700;
        }

        .stat-unit {
          font-size: 12px;
          color: #909399;
        }
      }

      .stat-label {
        font-size: 13px;
        color: #606266;
        margin-bottom: 4px;
      }

      .stat-threshold {
        font-size: 11px;
        color: #909399;
      }
    }
  }
}

// 审核信息
.audit-info {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;

  .audit-item {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    background: #fafafa;
    border-radius: 6px;

    &.full {
      grid-column: span 2;
    }

    .audit-label {
      font-size: 13px;
      color: #909399;
      width: 70px;
      flex-shrink: 0;
    }

    .audit-value {
      font-size: 13px;
      color: #303133;
    }
  }
}

// 抽屉底部
.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 20px;
  background: #fff;
  border-top: 1px solid #EBEEF5;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  z-index: 10;
  transition: opacity 0.3s;
}
</style>
